<template>
  <div class="nftbox">
    <mt-loadmore
      :top-method="loadTop"
      :bottom-all-loaded="allLoaded"
      :bottom-method="loadBottom"
      :autoFill="autoFill"
      :topPullText="null"
      :topDropText="null"
      :bottomPullText="null"
      :bottomDropText="null"
      :topLoadingText="null"
      :bottomLoadingText="null"
      ref="loadmore"
    >
      <div
        class="nftitem"
        @click="
          $router.push({ path: '/nfthistoryinfo', query: { id: item.id } })
        "
        v-for="(item, index) in list"
        :key="index"
      >
        <img
          :src="item.image"
          style="width: 80px; height: 80px; object-fit: cover"
        />
        <div class="right">
          <div class="title">
            <img
              src="../assets/img/home/nfthistory2.png"
              style="width: 12px; margin-right: 6px; vertical-align: top"
            /><span>{{ item.name }}</span>
          </div>
          <div style="font-size: 10px; color: #7b7a8a">
            {{ $t("编号") }} {{ item.tokenid }}
          </div>
          <div style="font-size: 10px; color: #7b7a8a">
            {{ $t("时间") }}: {{ item.createtime_text }}
          </div>
        </div>
      </div></mt-loadmore
    >
  </div>
</template>
<script>
import { outNftwithdrawLog } from ".././api/nft";
// import { timeformat } from "../utils/timeformat";
export default {
  props: ["alive"], //控制组件是否启用缓存
  data() {
    return {
      autoFill: false,
      allLoaded: false,
      list: [],
      payload: { limit_begin: 0, limit_num: 20 },
    };
  },
  activated() {
    if (this.alive) {
      this.payload = { limit_begin: 0, limit_num: 20 };
    } else {
      this.list = [];
      this.loadTop();
      this.payload = { limit_begin: 0, limit_num: 20 };
    }
    // console.log(10086);
  },
  //   created() {
  //     console.log(10086);
  //   },
  // watch: {
  //   nftvalue: {
  //     handler(val1, val2) {
  //       if (val1 == this.shownft) {
  //         if (this.list.length > 0) {
  //           return false;
  //         } else {
  //           this.loadTop();
  //         }
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    // timeformat,
    loadTop() {
      let _this = this;
      this.list = [];
      setTimeout(() => {
        _this.allLoaded = false;
        _this.payload.limit_begin = 0;
        this.getnftlog();
        _this.$refs.loadmore.onTopLoaded();
      }, 1000);
    },
    loadBottom() {
      let _this = this;
      setTimeout(() => {
        this.getnftlog();
        // if (_this.pageNo * 10 <= _this.array_pages) {
        //   _this.pageNo++;
        //   this.list.push(1);
        // } else {
        //   _this.allLoaded = true;
        // }
        _this.$refs.loadmore.onBottomLoaded();
      }, 1000);
    },

    getnftlog() {
      outNftwithdrawLog(this.payload).then((res) => {
        if (this.list.length < res.data.count) {
          this.list.push(...res.data.list);
          this.payload.limit_begin++;
        } else {
          _this.allLoaded = true;
        }
      });
    },
  },
};
</script>
<style scoped>
.nftbox {
  padding-top: 10px;
  height: 90vh;
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.nftitem {
  margin: 10px 0;
  display: flex;
}
/* /deep/.mint-loadmore-bottom {
  display: none;
} */
.right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 14px;
}
.title {
  font-size: 12px;
}
/deep/.mint-loadmore {
  height: 100%;
  overflow: auto;
}
</style>
